import { render, staticRenderFns } from "./AutocompleteProduct.vue?vue&type=template&id=83582e80"
import script from "./AutocompleteProduct.vue?vue&type=script&lang=js"
export * from "./AutocompleteProduct.vue?vue&type=script&lang=js"
import style0 from "./AutocompleteProduct.vue?vue&type=style&index=0&id=83582e80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports